<template>
  <div>
    <vs-card>
      <b-col cols="12" style="padding: 0; padding-right: 20px">
        <b-row align-h="end">
          <b-col
            cols="12"
            md="auto"
            style="padding: 0"
            @click="getTedarikciSiparisleri('Aktif')"
            ><vs-chip color="success">
              Aktif
            </vs-chip>
          </b-col>

          <b-col
            cols="12"
            md="auto"
            style="padding: 0"
            @click="getTedarikciSiparisleri('Iptal')"
            ><vs-chip color="danger">
              İptal
            </vs-chip>
          </b-col>
          <b-col
            cols="12"
            md="auto"
            style="padding: 0"
            @click="getTedarikciSiparisleri('Tamamlandı')"
            ><vs-chip color="warning">
              Tamamlandı
            </vs-chip>
          </b-col>
        </b-row>
      </b-col>
      <ag-grid-vue
        style="width: 100%; height: 400px; "
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowdata"
        :localeText="localeText"
        :suppressCopyRowsToClipboard="true"
        :animateRows="true"
        :groupDisplayType="groupDisplayType"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
        :autoGroupColumnDef="autoGroupColumnDef"
      >
      </ag-grid-vue>
      
    </vs-card>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import DateGorunumCellRenderer from "./CellRenderers/DateGorunumCellRenderer.vue"
import DurumGorunumCellRenderer from "./CellRenderers/DurumGorunumCellRenderer.vue";
import moment from "moment";
export default {
  data() {
    return {
      groupDisplayType: null,
      autoGroupColumnDef: null,
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null
    };
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
    this.groupDisplayType = 'groupRows';
    this.getTedarikciSiparisleri();
    this.autoGroupColumnDef = {
      minWidth: 150,
    };
  },
  components: {
    Icon,
    AgGridVue,
    DateGorunumCellRenderer,
    TextGorunumCellRenderer,
    DurumGorunumCellRenderer
  },
  methods: {
    parseDate(date) {
      if (typeof date == "undefined" || date == null) return "";
      return moment(String(date)).format("DD.MM.YYYY");
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getTedarikciSiparisleri(durum) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        durum: typeof durum == "undefined" ? "Aktif" : durum
      };

      soap.createClient(url, function(err, client) {
        client.xmlSiparisList(args, function(err, result) {
          if (result.xmlSiparisListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler2 = JSON.parse(result.xmlSiparisListResult);
            vm.rowdata = vm.veriler2.jsonData;
            console.log(vm.rowdata)
          } catch (error) {
            console.log(error);
          }
        });
      });
    }
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("getTedarikciSiparisleri", () => {
      this.getTedarikciSiparisleri();
    });
  },
  beforeDestroy() {
    this.$root.$off("getTedarikciSiparisleri");
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Tedarikçi",
        field: "tedarikci",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        rowGroup: true,
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Sipariş Numarası",
        field: "orderNumber",
        sortable: true,
        filter: "agSetColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Barkod",
        field: "barcode",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Stok Adı",
        field: "productName",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true
      },

      {
        headerName: "Tedarikçi Barkod",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "tedarikciBarkod",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Tedarikçi Ürün Adı",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "stokName",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        wrapText: true,
        autoHeight: true
      },
      {
        headerName: "Adet",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "quantity",
        cellRenderer: "TextGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },

      {
        headerName: "Gönderim Tarihi",
        field: "gonderimTarihi",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "DateGorunumCellRenderer",
       
      
      },
      {
        headerName: "Gelen Tarihi",
        field: "gelenTarih",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "DateGorunumCellRenderer",
    //    valueFormatter: params => this.parseDate(params.data.gelenTarih)
      },

      {
        headerName: "Durum",
        field: "durum",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        cellRenderer: "DurumGorunumCellRenderer"
      }
    ];
  }
};
</script>
